import { render, staticRenderFns } from "./ov-questionnaire.vue?vue&type=template&id=16f6d0ed&"
import script from "./ov-questionnaire.vue?vue&type=script&lang=js&"
export * from "./ov-questionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports